import { Component } from "react";

export default class ClubHouse extends Component {
    render() {
        return (
            <div className="club-house">
                <div className="page-content">
                    <header>
                        <h1 className="text-color-green">Im Aufbau...</h1>
                    </header>
                </div>
            </div>
        );
    }
}